var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as ColorImageFactory from '../../../classes/definitions/product/colorImage';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import Config from '../../../config/config';
import colorImageSchema from '../../../schemas/colorImageSchema';
import Input from '../../UI/Input/Input';
var ColorImageForm = /** @class */ (function (_super) {
    __extends(ColorImageForm, _super);
    function ColorImageForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.parentProductId = '';
        _this.parentVariantId = '';
        _this.editId = '-1';
        _this.messages = null;
        // public imageChanged: boolean = false; // this will determine if the image has been changed
        // // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(colorImageSchema),
            formIsValid: false,
        };
        _this.getColorImage = function (productId, variantId) {
            _this.api
                .getColorImage(productId, variantId)
                .then(function (response) {
                var respData = _.get(response, 'data.data', null);
                if (respData) {
                    _this.editId = respData.id;
                    _this.setDataToForm(_.get(response, 'data.data'));
                }
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на цветова картинка';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.deleteColorImage = function () {
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0446\u0432\u0435\u0442\u043E\u0432\u0430\u0442\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430?");
            if (ask) {
                _this.api
                    .deleteColorImage(_this.parentProductId, _this.parentVariantId, _this.editId)
                    .then(function (response) {
                    _this.toVariantPage();
                })
                    .catch(function (error) {
                    var defaultMessage = 'Грешка при изтриването на цветовата картинка';
                    _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
                });
            }
        };
        _this.setDataToForm = function (data) {
            var colorImage = ColorImageFactory.createColorImage(_.get(data, 'attributes', {}));
            var colorImageUrl = colorImage.ImageUrl ? Config.cdnDomain + colorImage.ImageUrl : null;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'image_url.value', colorImageUrl);
            _.set(updatedFormConfig, 'image_url.touched', true);
            _.set(updatedFormConfig, 'image_url.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedFormData = new FormData();
            var image = _.get(formData, 'image_url.value', null);
            submittedFormData.append('color_image[image]', image);
            var actionMethod = _this.editId === '-1' ? _this.api.createColorImage : _this.api.updateColorImage;
            actionMethod(submittedFormData, _this.parentProductId, _this.parentVariantId, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toVariantPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на цветова картинка';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toVariantPage = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentProductId + AppRoutes.variant.path + '/' + _this.parentVariantId);
        };
        return _this;
    }
    ColorImageForm.prototype.componentDidMount = function () {
        this.parentProductId = _.get(this.props, 'match.params.id', '-1');
        this.parentVariantId = _.get(this.props, 'match.params.variantId', '-1');
        // load edit value
        if (this.parentProductId !== '-1' && this.parentVariantId !== '-1') {
            this.getColorImage(this.parentProductId, this.parentVariantId);
        }
    };
    ColorImageForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toVariantPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-danger", onClick: this.deleteColorImage, disabled: !formIsValid || this.editId === '-1', type: "button" },
                React.createElement("i", { className: "fa fa-trash" }),
                " \u0418\u0437\u0442\u0440\u0438\u0439"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return ColorImageForm;
}(React.Component));
// @ts-ignore
export default withRouter(ColorImageForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/ColorImages/ColorImageForm/ColorImageForm.tsx
// module id = 337
// module chunks = 0